const becomeSellerBt = {
	breadcrumbs: {
		home: 'ཁྱིམ་',
		becomeSeller: 'ཚོང་པ་འགྱུར།'
	},
	hero: {
		title: 'ཚོང་པ་འགྱུར།',
		subtitle: 'གྲམ་གྱི་ཚོང་ཁང་དང་མཉམ་འབྲེལ་བྱས་ནས་ཁྱེད་ཀྱི་ཚོང་ལས་ཡར་འཕེལ་བྱེད།',
		cta: 'ད་ལྟ་འགོ་འབོད།'
	},
	stats: [
		{ value: '50,000+', label: 'ཤུགས་ལྡན་ཚོང་པ་' },
		{ value: '98%', label: 'དུས་ཚོད་ལེན་འགྲོ་པའི་སྤྲོད་དངུལ་' },
		{ value: '300%', label: 'ཆེས་ཆེར་འཕེལ་བའི་བཙོང་ཚོང་' },
		{ value: '4.8/5', label: 'ཚོང་པའི་སྐྱོན་མེད་དགའ་ཉམས་' }
	],
	benefits: {
		title: 'ཚོང་པ་འགྱུར་ནིའི་ཕན་ཡོན་',
		items: [
			{ title: 'བཙོང་ཚོང་ཡར་འཕེལ་', description: 'དེང་སང་གི་མཁས་པ་མང་པོའི་ཚོང་མཁན་ཚོའི་ཁར་ཐེབས་མིང་སྤེལ།' },
			{ title: 'དངུལ་ལེན་མང་པོ་', description: 'སླར་སླར་འབད་རུང་གི་ཁྲིམས་འགལ་མེད་པའི་སྤྲོད་དངུལ་' },
			{ title: '24/7 རམ་འདེགས་', description: 'ང་ཚོའི་བཟོ་ལྟའི་རམ་འདེགས་ཚོགས་པ་ཡོད།' },
			{ title: 'མཐའ་བཙན་ལེན་འགྲུབ་', description: 'དངུལ་སྤྲོད་ལེན་གྱི་ལས་ཁུངས་མཐའ་བཙན་དང་གསལ་བསྒྲགས་' },
			{ title: 'མྱུར་དུ་སྒྲིག་འགོད་', description: '24 ཆུ་ཚོད་ནང་ཁྱེད་ཀྱི་ཚོང་ཁང་འགོ་འབྱེད།' },
			{ title: 'བཙོང་ཚོང་དཔྱད་ཞིབ་', description: 'རྒྱས་པའི་སྙན་ཞུ་དང་དཔྱད་ཞིབ་གནང་།' }
		]
	},
	steps: {
		title: 'དང་པོ་འགོ་བཙུགས་ཐབས་',
		stepNumbers: ['༡', '༢', '༣'],
		items: [
			{ title: 'ཐོ་འགོད་', description: 'རྩིས་ཁྲེལ་དང་ཚོང་པའི་གནས་ཚུལ་བྱས་ནས་ཐོ་འགོད་འབད།' },
			{ title: 'ཞིབ་བཤེར་', description: 'ང་ཚོའི་རུས་པ་ཚོགས་པས་ 24 ཆུ་ཚོད་ནང་ཞིབ་བཤེར་དང་གནང་བ།' },
			{ title: 'བཙོང་ཚོང་འགོ་འབྱེད་', description: 'ཐེབས་ཡར་འཇུག་དང་བཙོང་ཚོང་འགོ་འབྱེད།' }
		]
	},
	cta: {
		title: 'ད་ལྟ་ཁྱེད་ཀྱི་ཌི་ཇི་ཊཱལ་ཚོང་ལས་འགོ་འབྱེད།',
		subtitle: 'གྲམ་གྱི་ཚོང་ཁང་དང་མཉམ་འབྲེལ་བྱས་ནས་ཚོང་ལས་ཡར་འཕེལ་བྱེད།',
		button: 'ཚོང་པ་སྦེ་མཐུད།'
	},
	transformDreams: {
		title: "གྲ་མེན་བཛར་དང་མཉམ་དུ་ཁྱེད་ཀྱི་རྨོངས་པ་དོན་ཡོད་བཟོ།",
		content: [
			"ཁྱེད་ཀྱི་ཚོང་འབད་བ་ག་གིས་འཕེལ་བཞིན་ཡོད་ཟེར་སེམས་ལ་བསམ་དགོས – ངོ་ཤེས་པའི་ངོ་གསལ་ཚུ་ཙམ་ཅིག་མ་ཡིན་པར་ གྲོང་རྡལ་རེ་རེ་ནས་འོད་ཟེར་གསལ་པའི་གནད་དོན་གསརཔ་ཚུ་གིས། ཁྱེད་ལ་དང་པོ་རང་གཅིག་གིས་འཚོལ་ཏེ་ཐོབ་ནུས། གྲ་མེན་བཛར་ནང་ལུ་ ཁྱེད་གི་ཐོག་མཛོད་ཚུ་ ནམ་ཡང་དངུལ་རྒྱབས་མ་བྱུང་མི་མི་ཚུའི་ཉིན་རེའི་འཚོ་བའི་ཡན་ལག་ཅན་གྱི་ཆ་མེད་མིན་འགྱུར།",
			"ང་ཚོའི་ཤུགས་ལྡན་པའི་དར་སྤྲོད་ནི་གྲོང་སྡེ་རྒྱལ་ལུང་ལུ་གཏོང་ཞིང་ མཐུན་འབྲེལ་བྱུང་མི་ཚུ་དང་ཆ་བཞགཔ་ཚུ་གཅིག་ཁར་འབྱོར་བཅུག་གི་ཡོདཔ། ང་ཚོའི་ཉེར་སྤྱོད་དཔྱད་ཞིབ་གསརཔ་འདི་གིས་སྤྲུལ་གྱི་ག་གིས་མཛད་མི་སྟོན་ཡོདཔ། རྩོམ་སྒྲིག་ལ་བཀོདཔ་ལས་ ང་ཚོའི་རྩ་འཛུགས་གཅིག་ལས་ 30% ནི་ དང་པོ་རང་གིས་གཟིགས་མེད་པའི་མི་ཚུ་ཡིན་པས་ ཁྱེད་ལས་ཉོ་བའི་དོན་ལས་གྲོས་འདོན་བྱེད་དགོས་མཁོ་ཡོདཔ་དང་བསུ་ནི་ལ་ཡོདཔ།",
			"འདི་ནི་ཁྱེད་ཀྱིས་སྔོན་མ་འཐོབ་པའི་གནས་ཚུལ་ཅིག་ཨིན་ – མི་ཚུ་གི་འབྱུང་བ་མ་སྦྱོང་པ་ཚུར་སྤྱོད་པ་ ཁོང་ཚུ་ཁྱེད་ཀྱི་སྲོད་གྲོན་ནང་བཞག་པ་ དང་ཁྱེད་ཀྱི་ཚོང་ཤོག་ཚུ་ 50% ལས་ 100% ཡང་དག་ཡར་འཕེལ་བ་ལས་བསྒྲུབ། གྲ་མེན་བཛར་ལུ་ཚུད – དེ་ནི་རྟེན་འབྲེལ་ཙམ་ཅིག་མིན་པར་ འགུལ་སྤྱོད་ཅན་ཅིག་ཨིན།",
			"ངེད་ཀྱིས་གཅིག་ཁར་རྩེད་ནས་ རེ་བ་ གོང་འཕེལ་དང་འབྱོར་འབུལ་ཁྱེད་ཀྱི་ནང་མི་ནང་ ཁྱེད་ཀྱི་གྲོང་སྡེ་ལུ་ ཁྱེད་ཀྱི་རྨོངས་པ་ལུ་འབྲེལ་ཞིབ་ནི་བསྐྱོད་ནི་ལུ་སྒྲིག་པ། མཁས་པ་ཚུ་བསྒུག་འདུག – ད་ལྟོ་ཁྱེད་ཀྱིས་འོད་ཟེར་འཕྲོ་དགོས་མཁོ་ཡོདཔ།"
		]
	}
	
};

export default becomeSellerBt;


